import styled from 'styled-components';

export default styled.pre`
    font-size: .875rem;
    word-break: break-word;
    word-wrap: break-word;
    overflow:hidden;
    white-space: pre-wrap;
    font-family: inherit;
    color: inherit;
`;
